export const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_486d2101-740c-43c8-a186-f704267080f2/artifacts/fc52f4843103ba2e_IMG_6586.webp";

const SIZES = {
  sm: "w-9 h-9",
  md: "w-11 h-11",
  lg: "w-24 h-24 sm:w-28 sm:h-28",
  xl: "w-32 h-32 sm:w-40 sm:h-40",
};

export const Logo = ({ size = "md", className = "", testId = "brand-logo" }) => (
  <span
    data-testid={testId}
    className={`${SIZES[size]} rounded-full overflow-hidden bg-black ring-1 ring-gold/50 shadow-[0_0_20px_rgba(212,175,55,0.25)] shrink-0 inline-block ${className}`}
  >
    <img
      src={LOGO_URL}
      alt="B&H Truck Dispatching logo"
      className="w-full h-full object-cover scale-[1.45]"
      loading="eager"
    />
  </span>
);
